<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  batchComputed,
  authComputed,
  batchListMethod,
  siteListMethod,
  courseListMethod,
  userListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Add batch',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      name: '',
      batchError: null,
      batchDataStatus: false,
      isBatchError: false,
      isLoading: false,
      show: false,
      siteconfiglist: [],
      platformId: 0,
      assignedTo: [],
      courselist: [],
      teacherlist: [],
      userlist: [],
      courseId: [],
      teacherId: [],
    }
  },
  computed: {
    ...batchComputed,
    ...authComputed,
  },
  mounted() {
    this.getListOfCollege()
    this.getListOfCourses()
    this.getListOfUsers()
    if (this.currentUser.user.role === 'college') {
      this.getListOfTeachers()
    }
    this.platformId = this.currentUser.user.platform_id
  },
  methods: {
    ...batchListMethod,
    ...siteListMethod,
    ...courseListMethod,
    ...userListMethod,

    // save batch method
    saveBatch() {
      if (this.role === 'college') {
        const batchData = {
          name: this.name,
          course_id: this.courseId,
          assigned_to: this.assignedTo,
          platform_id: this.platformId,
          teacher_id: this.teacherId,
        }
        this.isLoading = true
        this.addBatchData({ batchData })
          .then((batch) => {
            this.isLoading = false
            this.$router.push({ name: 'batch.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.batchError = getError.message
            this.isBatchError = true
            window.scrollTo(0, 0)
          })
      } else {
        const batchData = {
          name: this.name,
          course_id: this.courseId,
          assigned_to: this.assignedTo,
          platform_id: this.platformId,
        }

        this.addBatchData({ batchData })
          .then((batch) => {
            this.isLoading = false
            this.$router.push({ name: 'batch.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.batchError = getError.message
            this.isBatchError = true
          })
      }
    },

    // get list of platform
    getListOfCollege() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getListOfCourses() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        sort: 'sort_order',
        order: '-1',
        limit: 10,
      }
      this.fetchCourseList({ filter })
        .then((courses) => {
          var listitems = []
          courses.docs.forEach((element) => {
            if (element.platform_id.includes(this.platformId)) {
              var ele = {}
              ele.text = element.name
              ele.value = {
                id: element._id,
                name: element.name,
              }
              listitems.push(ele)
            }
          })
          this.courselist = listitems
        })
        .catch((_error) => {})
    },

    getListOfUsers() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'first_name',
        order: '1',
      }
      this.fetchUserList({ filter })
        .then((users) => {
          var listitems = []
          users.docs.forEach((element) => {
            var ele = {}
            ele.text = element.first_name + ' ' + element.last_name
            ele.value = {
              id: element._id,
              name: element.first_name + ' ' + element.last_name,
            }
            listitems.push(ele)

            this.userlist = listitems
          })
        })
        .catch((_error) => {})
    },

    getListOfTeachers() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'first_name',
        order: '1',
      }
      this.fetchTeacherList({ filter })
        .then((teachers) => {
          var listitems = []
          teachers.docs.forEach((element) => {
            var ele = {}
            ele.text = element.first_name + ' ' + element.last_name
            ele.value = {
              id: element._id,
              name: element.first_name + ' ' + element.last_name,
            }
            listitems.push(ele)
            this.teacherlist = listitems
          })
        })
        .catch((_error) => {})
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isBatchError"
              variant="danger"
              v-html="batchError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="saveBatch"
            >
              <b-form-group label="Batch Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="name"
                  type="text"
                  placeholder="Enter Batch Name"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Select Course*" label-for="input-1">
                <b-form-select
                  v-model="courseId"
                  :options="courselist"
                  multiple
                ></b-form-select>
              </b-form-group>

              <b-form-group
                v-if="role === 'college'"
                label="Select Teacher*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="teacherId"
                  :options="teacherlist"
                  multiple
                >
                </b-form-select>
              </b-form-group>

              <b-form-group label="Select User*" label-for="input-1">
                <b-form-select
                  v-model="assignedTo"
                  :options="userlist"
                  multiple
                ></b-form-select>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/batch-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
</style>
